import { useMemo } from 'react'
import { UseFormClearErrors, UseFormSetError } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { MovePayload } from 'pages/NestedCustomers/types'
import { SourceWallet } from 'types/move/move'
import { roundNumberWithCommas } from 'utils/utils'

interface UseMoveFormValidationProps {
  sourceWallet: SourceWallet | null
  formValues: MovePayload
  clearErrors: UseFormClearErrors<MovePayload>
  setError: UseFormSetError<MovePayload>
}

export const useMoveFormValidation = ({
  sourceWallet,
  formValues,
  clearErrors,
  setError,
}: UseMoveFormValidationProps) => {
  const { t } = useTranslation()

  const isInsufficientBalance = useMemo(
    () => (sourceWallet?.balance ?? 0) <= 0,
    [sourceWallet?.balance]
  )

  const isExceedingMaxAmount = useMemo(
    () => Number(formValues?.amount || 0) > (sourceWallet?.balance ?? 0),
    [formValues?.amount, sourceWallet?.balance]
  )
  const validateAmount = (amount: string) => {
    const isAmountMoreThanBalance = Number(amount) > (sourceWallet?.balance ?? 0)

    const error =
      isAmountMoreThanBalance &&
      t('customers.amountErrorMaximum', {
        amount: roundNumberWithCommas(sourceWallet?.balance ?? 0),
        currencyCode: sourceWallet?.currency,
      })

    if (error) {
      setError('amount', { message: error })
    } else {
      clearErrors('amount')
    }
  }

  return {
    validateAmount,
    isInsufficientBalance,
    isExceedingMaxAmount,
  }
}
